import React, { useEffect, useState } from "react";
import ProfileSidebar from "../../components/main/profil";
import TabsSection from "../../components/main/content";
import ModernTheme from "../../themes/ModernTheme";
import TerminalTheme from "../../themes/TerminalTheme";
import FabricaTheme from "../../themes/FabricaTheme";
import AuroraTheme from "../../themes/AuroraTheme";
import { getSettings } from "../../api/settingsAPI";

const ClassicTheme = () => (
  <div className="min-h-screen bg-[#0d0d10]">
    <div className="fixed inset-0 bg-[radial-gradient(ellipse_at_top,rgba(59,130,246,0.05)_0%,transparent_60%)] pointer-events-none" />
    <div className="relative w-full max-w-screen-2xl mx-auto px-3 sm:px-5 xl:px-10 py-6">
      <div className="flex flex-col lg:flex-row gap-5">
        <div className="w-full lg:w-[280px] xl:w-[300px] flex-shrink-0">
          <ProfileSidebar />
        </div>
        <div className="flex-1 min-w-0">
          <TabsSection />
        </div>
      </div>
    </div>
  </div>
);

const MainPage = () => {
  const [theme, setTheme] = useState(null);

  useEffect(() => {
    getSettings()
      .then((s) => setTheme(s.active_theme ?? "classic"))
      .catch(() => setTheme("classic"));
  }, []);

  if (theme === null) {
    return (
      <div className="min-h-screen bg-[#0d0d10] flex items-center justify-center">
        <div className="flex gap-1.5">
          <span className="w-2 h-2 bg-indigo-500 rounded-full animate-bounce" style={{ animationDelay: "0ms" }} />
          <span className="w-2 h-2 bg-indigo-500 rounded-full animate-bounce" style={{ animationDelay: "150ms" }} />
          <span className="w-2 h-2 bg-indigo-500 rounded-full animate-bounce" style={{ animationDelay: "300ms" }} />
        </div>
      </div>
    );
  }

  if (theme === "modern") return <ModernTheme />;
  if (theme === "terminal") return <TerminalTheme />;
  if (theme === "fabrica") return <FabricaTheme />;
  if (theme === "aurora") return <AuroraTheme />;
  return <ClassicTheme />;
};

export default MainPage;
